module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-800.bb04b283.png";